/**
 * Správa uživatelů (jen superadmin) — endpointy tickets-portalu vedle
 * přihlášení, takže jdou stejnou cestou/proxy jako `/api/auth/login`.
 *
 *   GET  /api/auth/users                 → { users }
 *   POST /api/auth/users/:id/password    { password } → { ok, signedOut }
 */
import { AUTH_API_URL } from "./auth.js";

export interface PortalUser {
  id: string;
  email: string;
  name: string | null;
  nickname: string | null;
  role: string;
  isActive: boolean;
  createdAt: string | null;
}

async function call<T>(
  path: string,
  accessToken: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(`${AUTH_API_URL}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as {
      error?: string;
    } | null;
    throw new Error(
      body?.error ??
        (res.status === 403
          ? "K téhle akci je potřeba role superadmin."
          : `Požadavek selhal (HTTP ${res.status})`),
    );
  }
  return (await res.json()) as T;
}

export async function fetchUsers(accessToken: string): Promise<PortalUser[]> {
  const data = await call<{ users: PortalUser[] }>(
    "/api/auth/users",
    accessToken,
  );
  return data.users;
}

export function setUserPassword(
  accessToken: string,
  userId: string,
  password: string,
): Promise<{ ok: true; signedOut: boolean }> {
  return call(`/api/auth/users/${userId}/password`, accessToken, {
    method: "POST",
    body: JSON.stringify({ password }),
  });
}
